import { IRoleEnum } from '../../../types/router'

import { joinClassNames } from '../../../utils/styles'
import styles from './role-select.module.scss'
interface IRoleSelectProps {
    role: IRoleEnum
    setRole: React.Dispatch<React.SetStateAction<IRoleEnum>>
    className?: string
}

function RoleSelect(props: IRoleSelectProps) {
    const { role, setRole, className } = props

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setRole(Number(e.target.value))
    }

    return (
        <select
            className={joinClassNames(styles.roleSelect, className)}
            value={role}
            onChange={handleSelectChange}
        >
            <option value={IRoleEnum.USER}>USER</option>
            <option value={IRoleEnum.ADMIN}>ADMIN</option>
        </select>
    )
}

export default RoleSelect
